import isEmpty from 'lodash/isEmpty';
import {GroupFragment} from '../graphql/generated/types';
import {initializeFetchStatus} from './initializeFetchStatus.function';
import {initializeItemState} from './initializeItemState.function';
import {initializeParentRelation} from './initializeParentRelation.function';
import {PagewebLayoutState} from './PagewebLayoutState.interface';

/**
 * 주의 : mutable. immer 가 적용된 경우만 사용해야함
 */
export function initializeGroupState({
  state,
  id,
  parentId,
  group,
  error,
  isNestedGroup,
}: {
  id: string;
  /**
   * groupId or sectionId
   */
  parentId: string;
  state: PagewebLayoutState;
  isNestedGroup: boolean;
  group?: GroupFragment;
  error?: Error;
}) {
  const isEnoughData =
    !!group &&
    (!group.dataKey || !isEmpty(group.groups) || !isEmpty(group.items));
  initializeFetchStatus({
    state,
    id,
    isEnoughData,
    error,
  });
  if (!group) {
    return;
  }
  if (isNestedGroup) {
    state.relations.nestedGroups[parentId].childrenIds.push(id);
  } else {
    state.relations.sections[parentId].childrenIds.push(id);
  }

  const {groups, items, ...entity} = group;
  state.entities.groups[id] = entity;
  initializeParentRelation({
    state,
    relationKey: 'nestedGroups',
    id,
    parentId,
  });
  groups?.forEach(nestedGroup => {
    initializeGroupState({
      state,
      parentId: id,
      id: nestedGroup.id,
      group: nestedGroup,
      isNestedGroup: true,
    });
  });
  initializeParentRelation({
    state,
    relationKey: 'groups',
    id,
    parentId,
  });
  items?.forEach(item => {
    initializeItemState({state, parentId: id, id: item.id, item});
  });
}
